import { fetchCreationImageBlob } from "../services/api/editor/background_removal";
import logger from "./logger";

/**
 * Prefer same-origin creation blob for canvas display (avoids S3 CORS on AWS).
 * Falls back to outputUrl when no creationId or fetch fails.
 */
export async function resolveCreationImageUrl(token, outputUrl, creationId) {
  const cid =
    creationId != null && !Number.isNaN(Number(creationId))
      ? Number(creationId)
      : null;

  const isAlreadyLocal =
    typeof outputUrl === "string" &&
    (outputUrl.startsWith("blob:") || outputUrl.startsWith("data:"));

  if (isAlreadyLocal) {
    return { displayUrl: outputUrl, creationId: cid };
  }

  if (cid && cid > 0 && token) {
    try {
      const blob = await fetchCreationImageBlob(token, cid);
      return { displayUrl: URL.createObjectURL(blob), creationId: cid };
    } catch (err) {
      logger.error(
        "Creation image fetch failed; canvas may not load S3 URL without CORS",
        err
      );
    }
  }

  return { displayUrl: outputUrl, creationId: cid };
}

/** Fetch a remote CDN URL as a blob URL for canvas display (CORS-safe). */
export async function fetchRemoteImageBlob(url) {
  if (!url || typeof url !== "string") {
    return url;
  }
  if (url.startsWith("blob:") || url.startsWith("data:")) {
    return url;
  }

  const res = await fetch(url, { mode: "cors" });
  if (!res.ok) {
    throw new Error(`Failed to fetch image (${res.status})`);
  }
  return URL.createObjectURL(await res.blob());
}
